import { LitElement, html, query } from 'lit-element'
import { SVG_WINDOWS } from '@getgo/chameleon-icons'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'
import windowsSupportBannerStyles from './windows-support-banner.styles.scss'
import { getTranslation } from '../../services/i18n/i18nUtils'
import { getOS } from '../../common/user-agent-helpers'
import { canShowTrialBanner } from '../../core/hooks/trial-banner'
import { BannerComponent } from '@getgo/chameleon-web'

export class WindowSupportBanner extends LitElement {
  static readonly tagName = 'goto-windows-support'
  @query('chameleon-banner') private chameleonBanner!: BannerComponent

  learnMoreLink = 'https://support.goto.com/connect/help/how-do-i-download-and-install-the-goto-app'

  static get styles() {
    return windowsSupportBannerStyles
  }

  private getBannerMessage() {
    const windowsVersion = this.getWindowsVersion()
    return getTranslation(
      `Windows {{windowsVersion}} is no longer supported. For new GoTo updates, you'll need Windows 10 or higher.`,
      { windowsVersion },
    )
  }

  private getBannerLinkText() {
    return getTranslation('Learn more')
  }

  private getWindowsVersion() {
    const osVersion = getOS().version
    switch (osVersion) {
      case '6.1':
        return '7'
      case '6.2':
        return '8'
      case '6.3':
        return '8.1'
      default:
        return '7 & 8'
    }
  }

  private getClosable() {
    // If the user also has a trial banner, this banner must be closable
    if (canShowTrialBanner()) {
      return true
    }
    return false
  }

  render() {
    return html`<chameleon-banner ?closable=${this.getClosable()} @close=${() => this.chameleonBanner.remove()}>
      <chameleon-svg slot="icon">${unsafeSVG(SVG_WINDOWS)}</chameleon-svg>
      <span>${this.getBannerMessage()}</span>
      <a slot="action" class="windows-support-banner-link" href="${this.learnMoreLink}" target="_blank">
        ${this.getBannerLinkText()}
      </a>
    </chameleon-banner>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [WindowSupportBanner.tagName]: WindowSupportBanner
  }
}
